<template>
  <div class="page course-consumed-page">
    <div class="top course-top">
      <van-search
        v-model="keyword"
        placeholder="搜索学员姓名"
        shape="round"
        style="padding-bottom: 0"
        @search="onSearch"
      />
      <div class="date-filter">
        <div class="date-row">
          <span class="date-label date-label-select" @click="openTimeFilterPicker">
            {{ timeFilterLabel }}<van-icon name="arrow-down" class="date-label-select-icon" />
          </span>
          <span class="date-value" @click="openDateRangePicker">{{ activeRangeStartDate || "开始日期" }}</span>
          <span class="date-sep">-</span>
          <span class="date-value" @click="openDateRangePicker">{{ activeRangeEndDate || "结束日期" }}</span>
          <span v-if="activeRangeStartDate || activeRangeEndDate" class="date-clear" @click="clearRange">清空</span>
        </div>
        <div class="date-row">
          <span class="date-label">中心</span>
          <span class="date-value date-value--wide" @click="openTopDepartmentPicker">{{ filterTopDepartmentLabel || "全部中心" }}</span>
          <span
            v-if="filters.topDepartmentId !== null && filters.topDepartmentId !== undefined && filters.topDepartmentId !== ''"
            class="date-clear"
            @click="clearTopDepartmentFilter"
          >
            清空
          </span>
        </div>
        <div class="date-row">
          <span class="date-label">老师</span>
          <span class="date-value date-value--wide" @click="openTeacherFilterPicker">{{ filterTeacherLabel || "全部老师" }}</span>
          <span
            v-if="filters.teacherId !== null && filters.teacherId !== undefined && filters.teacherId !== ''"
            class="date-clear"
            @click="clearTeacherFilter"
          >
            清空
          </span>
        </div>
      </div>
      <div class="consume-summary-bar">
        <span v-if="shouldShowConsumeAmount(summary)" class="consume-summary-item">
          合计消耗金额
          <strong class="consume-summary-amount">{{ formatAmountDisplay(summary.totalConsumeAmount) }}</strong>
        </span>
        <span class="consume-summary-item">
          课消条数
          <strong class="consume-summary-count">{{ summary.totalCount }}</strong>
        </span>
      </div>
    </div>

    <div class="list course-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="records-wrap">
            <van-empty v-if="!items.length && !loading" description="暂无数据" class="empty" />
            <div v-for="row in items" :key="row.id" class="card consume-card">
              <div class="consume-card-top">
                <span class="consume-student-name">{{ row.studentName || "-" }}</span>
                <span v-if="shouldShowConsumeAmount(row)" class="consume-amount">{{ formatAmountDisplay(row.consumeAmount) }}</span>
              </div>
              <div class="consume-row">课包：{{ row.coursePackageName || "-" }}</div>
              <div class="consume-row consume-row--meta">
                <span>学员扣课课时：{{ formatConsumeNum(row.consumeNum) }}</span>
                <span>老师计算课时：{{ formatConsumeNum(row.teacherConsumeNum) }}</span>
              </div>
              <div class="consume-row">老师：{{ row.teacherName || "-" }}</div>
              <div class="consume-row">中心：{{ row.topDepartmentName || "-" }}</div>
              <div class="consume-row">上课日期：{{ (row.consumeDate || row.consumeTime || "").slice(0, 10) || "-" }}</div>
              <div class="consume-row">创建时间：{{ row.createTime || "-" }}</div>
              <div class="consume-actions">
                <van-button plain hairline round size="small" class="consume-op-btn consume-op-btn--edit" @click="openEdit(row)">编辑</van-button>
                <van-button plain hairline round size="small" class="consume-op-btn consume-op-btn--delete" @click="onDelete(row)">删除</van-button>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup v-model="formPopup.show" position="bottom" round :style="{ height: '58vh' }">
      <div class="booking-popup-wrap popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ formPopup.mode === "create" ? "新增课消" : "编辑课消" }}</div>
          <van-icon name="cross" class="popup-close" @click="formPopup.show = false" />
        </div>
        <div class="booking-popup-scroll popup-body">
          <van-field
            readonly
            clickable
            label="上课日期"
            :value="formPopup.form.consumeDate"
            placeholder="请选择上课日期"
            required
            @click="openConsumeDatePicker"
          />
          <van-field
            readonly
            clickable
            label="学员"
            :value="formStudentLabel"
            placeholder="请选择学员"
            required
            @click="openStudentPicker"
          />

          <van-field
            readonly
            clickable
            label="课包"
            :value="formCoursePackageLabel"
            :placeholder="formCoursePackagePlaceholder"
            required
            @click="openCoursePackagePicker"
          />
          <div v-if="remainInfo.loading" class="course-detail-panel course-detail-panel--loading">
            <van-loading size="16px">加载课包信息...</van-loading>
          </div>
          <div v-else-if="selectedPackageDetail" class="course-detail-panel">
            <div class="course-detail-meta">主课老师：{{ selectedPackageDetail.teacherName || formPopup.form.teacherName}}</div>
            <div class="course-detail-meta">{{ formatPackageRemainLabel(selectedPackageDetail) }}</div>
          </div>
          <div v-else class="course-detail-empty">{{ packageDetailHint }}</div>

          <van-field
            readonly
            clickable
            label="上课老师"
            :value="formTeacherLabel"
            placeholder="请选择老师"
            required
            @click="openFormTeacherPicker"
          />

          <van-field
            readonly
            clickable
            label="学员扣课课时"
            :value="formConsumeNumLabel"
            placeholder="请选择学员扣课课时"
            required
            @click="openConsumeNumPicker"
          />
          <van-field
            readonly
            clickable
            label="老师计算课时"
            :value="formTeacherConsumeNumLabel"
            placeholder="请选择老师计算课时"
            required
            @click="openTeacherConsumeNumPicker"
          />
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="formPopup.submitting" @click="submitForm">保存</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="studentPicker.show" position="bottom" round :style="{ height: '70vh' }">
      <div class="student-picker-inner">
        <div class="popup-head">
          <div class="popup-title">选择学员</div>
          <van-icon name="cross" class="popup-close" @click="closeStudentPicker" />
        </div>
        <van-search
          v-model="studentPicker.keyword"
          placeholder="搜索学员姓名"
          shape="round"
          @search="searchStudents"
          @input="onStudentKeywordInput"
        />
        <div class="student-list-wrap">
          <van-loading v-if="studentPicker.loading" class="panel-loading" size="20px" />
          <van-empty v-else-if="studentPicker.list.length === 0" description="暂无学员" class="panel-empty" />
          <div
            v-for="stu in studentPicker.list"
            :key="stu.studentId"
            :class="['student-item', { active: String(formPopup.form.studentId) === String(stu.studentId) }]"
            @click="selectStudent(stu)"
          >
            <div class="student-item-name">{{ stu.studentName || "-" }}</div>
            <div class="student-item-sub">
              {{ stu.topDepartmentName || "-" }}
              <template v-if="stu.packageCount"> · {{ stu.packageCount }} 个课包</template>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="picker.show" position="bottom">
      <van-picker show-toolbar :title="picker.title" :columns="picker.columns" @confirm="onPickerConfirm" @cancel="picker.show = false" />
    </van-popup>

    <van-calendar
      v-model="dateRangePickerShow"
      type="range"
      :min-date="dateRangePickerMinDate"
      :max-date="dateRangePickerMaxDate"
      :allow-same-day="true"
      :show-confirm="true"
      :default-date="dateRangePickerDefault"
      :z-index="5000"
      color="rgb(242, 124, 52)"
      @close="dateRangePickerShow = false"
      @confirm="onConfirmDateRange"
    />
    <van-calendar
      v-model="consumeDatePickerShow"
      type="single"
      :min-date="dateRangePickerMinDate"
      :max-date="dateRangePickerMaxDate"
      :default-date="consumeDatePickerDefault"
      :z-index="5001"
      color="rgb(242, 124, 52)"
      @close="consumeDatePickerShow = false"
      @confirm="onConfirmConsumeDate"
    />

    <div class="bottom-bar">
      <van-button type="primary" block round class="theme-btn" @click="openCreate">新增课消</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import { fetchTopDepartments, fetchStaffList } from "@/api/customer"
import {
  fetchCourseConsumedList,
  fetchCourseConsumedSummary,
  createCourseConsumed,
  updateCourseConsumed,
  deleteCourseConsumed,
  fetchStudentPackageRemain
} from "@/api/courseConsumed"
import { resetPageScrollAfterPaint } from "@/utils/scroll"

const STUDENT_CONSUME_NUM_OPTIONS = [
  { text: "0.5课时", value: 0.5 },
  { text: "1课时", value: 1 },
  { text: "1.5课时", value: 1.5 },
  { text: "2课时", value: 2 }
]

const TEACHER_CONSUME_NUM_OPTIONS = [
  { text: "0.5课时", value: 0.5 },
  { text: "0.6课时", value: 0.6 },
  { text: "1课时", value: 1 },
  { text: "1.5课时", value: 1.5 }
]

const TIME_FILTER_OPTIONS = [
  { text: "上课时间", value: "consume" },
  { text: "创建时间", value: "create" }
]

function formatDateOnly(date) {
  const dt = date instanceof Date ? date : new Date(date)
  const y = dt.getFullYear()
  const m = String(dt.getMonth() + 1).padStart(2, "0")
  const d = String(dt.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}

function getDefaultMonthRange() {
  const now = new Date()
  const first = new Date(now.getFullYear(), now.getMonth(), 1)
  return {
    startDate: formatDateOnly(first),
    endDate: formatDateOnly(now)
  }
}

function isValidDateString(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const [y, m, d] = value.split("-").map(Number)
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return false
  const dt = new Date(y, m - 1, d)
  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d
}

function normalizeList(value) {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.data)) return value.data
  if (Array.isArray(value?.list)) return value.list
  return []
}

function normalizeCoursePackageList(source) {
  if (!source || typeof source !== "object") return []
  const list = normalizeList(source.coursePackageList)
  return list.filter(x => x && x.id !== null && x.id !== undefined && x.id !== "")
}

function resolveRemainInfo(res, options = {}) {
  const { stuName, studentId } = options
  let raw = res && typeof res === "object" && res.data !== undefined ? res.data : res

  if (Array.isArray(raw)) {
    if (!raw.length) return null
    if (studentId !== null && studentId !== undefined && studentId !== "") {
      const byId = raw.find(x => String(x.studentId) === String(studentId))
      if (byId) return byId
    }
    const name = (stuName || "").trim()
    if (name) {
      const byName = raw.find(x => (x.studentName || "").trim() === name)
      if (byName) return byName
    }
    return raw.length === 1 ? raw[0] : null
  }

  if (!raw || typeof raw !== "object") return null
  return raw
}

function resolveRemainSearchList(res) {
  const raw = res && typeof res === "object" && res.data !== undefined ? res.data : res
  if (Array.isArray(raw)) {
    return raw.map(item => normalizeRemainStudentItem(item)).filter(Boolean)
  }
  const one = resolveRemainInfo(res)
  return one ? [normalizeRemainStudentItem(one)].filter(Boolean) : []
}

function normalizeRemainStudentItem(item) {
  if (!item || item.studentId === null || item.studentId === undefined || item.studentId === "") return null
  const packageList = normalizeCoursePackageList(item)
  return {
    studentId: item.studentId,
    studentName: item.studentName || "",
    topDepartmentName: item.topDepartmentName || "",
    packageCount: packageList.length,
    remainData: item
  }
}

export default {
  name: "CourseConsumed",
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      page: 1,
      pageSize: 20,
      items: [],
      summary: {
        totalConsumeAmount: 0,
        totalCount: 0,
        isShowAmount: true
      },
      scrollToTopAfterLoad: false,
      keyword: "",
      keywordTimer: null,
      filters: {
        timeFilterType: "consume",
        teacherId: null,
        topDepartmentId: null,
        createStartDate: "",
        createEndDate: "",
        consumeStartDate: "",
        consumeEndDate: ""
      },
      dateRangePickerShow: false,
      consumeDatePickerShow: false,
      dateRangePickerMinDate: new Date(1970, 0, 1),
      dateRangePickerMaxDate: new Date(2100, 11, 31),
      topDepartmentOptions: [],
      teacherOptions: [],
      formPopup: {
        show: false,
        mode: "create",
        submitting: false,
        form: {
          id: null,
          studentId: null,
          studentName: "",
          coursePackageId: null,
          coursePackageName: "",
          teacherId: null,
          teacherName: "",
          topDepartmentId: null,
          topDepartmentName: "",
          consumeDate: "",
          consumeNum: 1,
          teacherConsumeNum: 1
        }
      },
      remainInfo: {
        loading: false,
        loaded: false,
        data: null
      },
      studentPicker: {
        show: false,
        loading: false,
        keyword: "",
        keywordTimer: null,
        list: []
      },
      picker: {
        show: false,
        title: "",
        type: "",
        columns: []
      }
    }
  },
  computed: {
    dateRangePickerDefault() {
      const start = this.activeRangeStartDate
      const end = this.activeRangeEndDate
      if (!start || !end) {
        const today = new Date()
        const tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)
        return [today, tomorrow]
      }
      return [new Date(start.replace(/-/g, "/")), new Date(end.replace(/-/g, "/"))]
    },
    consumeDatePickerDefault() {
      const v = this.formPopup.form.consumeDate
      return v ? new Date(v.replace(/-/g, "/")) : new Date()
    },
    timeFilterLabel() {
      const hit = TIME_FILTER_OPTIONS.find(x => x.value === this.filters.timeFilterType)
      return hit ? hit.text : "上课时间"
    },
    activeRangeStartDate() {
      return this.filters.timeFilterType === "create" ? this.filters.createStartDate : this.filters.consumeStartDate
    },
    activeRangeEndDate() {
      return this.filters.timeFilterType === "create" ? this.filters.createEndDate : this.filters.consumeEndDate
    },
    filterTopDepartmentLabel() {
      const hit = this.topDepartmentOptions.find(x => String(x.value) === String(this.filters.topDepartmentId))
      return hit ? hit.text : ""
    },
    filterTeacherLabel() {
      const hit = this.teacherOptions.find(x => String(x.value) === String(this.filters.teacherId))
      return hit ? hit.text : ""
    },
    formStudentLabel() {
      return (this.formPopup.form.studentName || "").trim()
    },
    formCoursePackageLabel() {
      return (this.formPopup.form.coursePackageName || "").trim()
    },
    formCoursePackagePlaceholder() {
      if (!this.formPopup.form.studentId) return "请先选择学员"
      return "请选择课包"
    },
    packageDetailHint() {
      if (!this.formPopup.form.studentId) return "请先选择学员"
      if (this.remainInfo.loaded && !this.remainPackageList.length) return "暂无课包剩余课时"
      return "请选择课包"
    },
    selectedPackageDetail() {
      const form = this.formPopup.form
      const packageId = form.coursePackageId
      const packageName = (form.coursePackageName || "").trim()
      if ((packageId === null || packageId === undefined || packageId === "") && !packageName) return null

      let hit = null
      if (packageId !== null && packageId !== undefined && packageId !== "") {
        hit = this.remainPackageList.find(x => x.id === packageId) || null
      }
      if (!hit && packageName) {
        hit = this.remainPackageList.find(x => (x.coursePackageName || "").trim() === packageName) || null
      }
      if (hit) return hit

      if (packageId === null || packageId === undefined || packageId === "") return null
      return {
        id: packageId,
        coursePackageName: packageName,
        teacherName: form.teacherName || "",
        remainNum: null
      }
    },
    formConsumeNumLabel() {
      const hit = STUDENT_CONSUME_NUM_OPTIONS.find(x => Number(x.value) === Number(this.formPopup.form.consumeNum))
      return hit ? hit.text : ""
    },
    formTeacherConsumeNumLabel() {
      const hit = TEACHER_CONSUME_NUM_OPTIONS.find(x => Number(x.value) === Number(this.formPopup.form.teacherConsumeNum))
      return hit ? hit.text : ""
    },
    formTeacherLabel() {
      const name = (this.formPopup.form.teacherName || "").trim()
      if (name) return name
      const hit = this.teacherOptions.find(x => String(x.value) === String(this.formPopup.form.teacherId))
      return hit ? hit.text : ""
    },
    remainPackageList() {
      return normalizeCoursePackageList(this.remainInfo.data)
    }
  },
  watch: {
    keyword() {
      this.onKeywordInput()
    }
  },
  beforeDestroy() {
    if (this.keywordTimer) {
      clearTimeout(this.keywordTimer)
      this.keywordTimer = null
    }
  },
  created() {
    const { startDate, endDate } = getDefaultMonthRange()
    this.filters.consumeStartDate = startDate
    this.filters.consumeEndDate = endDate
    this.loadTopDepartments()
    this.loadTeachers()
    this.onRefresh()
  },
  methods: {
    formatAmountDisplay(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return "-"
      return `￥${n}`
    },
    shouldShowConsumeAmount(row) {
      const v = row?.isShowAmount
      if (v === false || v === 0 || v === "0" || v === "false") return false
      return true
    },
    formatConsumeNum(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return "-"
      return `${n}课时`
    },
    formatRemainNum(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    formatRemainDisplay(v) {
      if (v === null || v === undefined || v === "") return "-"
      const n = Number(v)
      return Number.isFinite(n) ? n : "-"
    },
    formatPackageRemainLabel(pkg) {
      if (!pkg || typeof pkg !== "object") return "-"
      const name = (pkg.coursePackageName || "").trim() || "-"
      const remain = pkg.remainNum ?? pkg.remainCourseNum
      return `${name}：剩余 ${this.formatRemainDisplay(remain)}`
    },
    formatCoursePackagePickerLabel(pkg) {
      if (!pkg || typeof pkg !== "object") return "-"
      const name = (pkg.coursePackageName || "-").trim()
      const remain = pkg.remainNum ?? pkg.remainCourseNum
      const total = pkg.courseNum ?? pkg.totalCourseNum
      return `${name} (${this.formatRemainDisplay(remain)}/${this.formatRemainDisplay(total)})`
    },
    resetRemainInfo() {
      this.remainInfo = {
        loading: false,
        loaded: false,
        data: null
      }
    },
    async loadTopDepartments() {
      try {
        const res = await fetchTopDepartments()
        const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : [])
        this.topDepartmentOptions = list
          .map(item => ({ text: item.weName || item.name || "-", value: item.weId ?? item.id }))
          .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
      } catch (e) {
        this.topDepartmentOptions = []
      }
    },
    async loadTeachers() {
      try {
        const res = await fetchStaffList({ displayStart: 1, displayLength: 500 })
        const list = normalizeList(res)
        this.teacherOptions = list
          .map(item => ({
            text: item.weName || item.name || item.staffName || "-",
            value: item.id ?? item.weId ?? item.staffId
          }))
          .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
      } catch (e) {
        this.teacherOptions = []
      }
    },
    buildFilterPayload() {
      const rangeFieldMap = {
        create: ["createStartDate", "createEndDate"],
        consume: ["consumeStartDate", "consumeEndDate"]
      }
      const [startField, endField] = rangeFieldMap[this.filters.timeFilterType] || rangeFieldMap.consume
      return {
        [startField]: this.activeRangeStartDate || undefined,
        [endField]: this.activeRangeEndDate || undefined,
        topDepartmentId:
          this.filters.topDepartmentId === null || this.filters.topDepartmentId === undefined || this.filters.topDepartmentId === ""
            ? undefined
            : Number(this.filters.topDepartmentId),
        teacherId:
          this.filters.teacherId === null || this.filters.teacherId === undefined || this.filters.teacherId === ""
            ? undefined
            : Number(this.filters.teacherId),
        stuName: (this.keyword || "").trim() || undefined
      }
    },
    buildSearchPayload() {
      return {
        ...this.buildFilterPayload(),
        displayStart: this.page,
        displayLength: this.pageSize
      }
    },
    resolveSummary(res) {
      const raw =
        res && typeof res === "object" && res.data !== undefined && !Array.isArray(res.data) ? res.data : res
      return {
        totalConsumeAmount: Number(raw?.totalConsumeAmount ?? raw?.totalAmount) || 0,
        totalCount: Number(raw?.totalCount) || 0,
        isShowAmount: raw?.isShowAmount
      }
    },
    async loadSummary() {
      try {
        const res = await fetchCourseConsumedSummary(this.buildFilterPayload())
        this.summary = this.resolveSummary(res)
      } catch (e) {
        this.summary = { totalConsumeAmount: 0, totalCount: 0, isShowAmount: true }
      }
    },
    resolveRows(res) {
      if (Array.isArray(res?.data)) return res.data
      if (Array.isArray(res?.records)) return res.records
      if (Array.isArray(res?.list)) return res.list
      if (Array.isArray(res)) return res
      return []
    },
    async fetchPage() {
      const res = await fetchCourseConsumedList(this.buildSearchPayload())
      return this.resolveRows(res)
    },
    async onLoad() {
      try {
        const list = await this.fetchPage()
        if (this.refreshing) {
          this.items = []
          this.refreshing = false
        }
        this.items = this.items.concat(list)
        this.finished = list.length < this.pageSize
        this.page += 1
      } catch (e) {
        this.finished = true
      } finally {
        this.loading = false
        if (this.scrollToTopAfterLoad) {
          this.scrollToTopAfterLoad = false
          this.$nextTick(() => resetPageScrollAfterPaint(this.$el))
        }
      }
    },
    onRefresh() {
      this.page = 1
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.loadSummary()
      this.onLoad()
    },
    onSearch() {
      this.onRefresh()
    },
    onKeywordInput() {
      if (this.keywordTimer) clearTimeout(this.keywordTimer)
      this.keywordTimer = setTimeout(() => {
        this.onRefresh()
      }, 350)
    },
    clearRange() {
      if (this.filters.timeFilterType === "create") {
        this.filters.createStartDate = ""
        this.filters.createEndDate = ""
      } else {
        this.filters.consumeStartDate = ""
        this.filters.consumeEndDate = ""
      }
      this.onRefresh()
    },
    openDateRangePicker() {
      this.dateRangePickerShow = true
    },
    openTimeFilterPicker() {
      this.picker.type = "filterTimeType"
      this.picker.title = "筛选时间类型"
      this.picker.columns = TIME_FILTER_OPTIONS
      this.picker.show = true
    },
    onConfirmDateRange(dates) {
      this.dateRangePickerShow = false
      const arr = Array.isArray(dates) ? dates : [dates]
      const start = arr[0]
      const end = arr[1] || arr[0]
      const startVal = start ? formatDateOnly(start) : ""
      const endVal = end ? formatDateOnly(end) : ""
      if (this.filters.timeFilterType === "create") {
        this.filters.createStartDate = startVal
        this.filters.createEndDate = endVal
      } else {
        this.filters.consumeStartDate = startVal
        this.filters.consumeEndDate = endVal
      }
      this.onRefresh()
    },
    openConsumeDatePicker() {
      this.consumeDatePickerShow = true
    },
    onConfirmConsumeDate(date) {
      this.consumeDatePickerShow = false
      this.formPopup.form.consumeDate = date ? formatDateOnly(date) : ""
    },
    clearTopDepartmentFilter() {
      this.filters.topDepartmentId = null
      this.onRefresh()
    },
    clearTeacherFilter() {
      this.filters.teacherId = null
      this.onRefresh()
    },
    openTopDepartmentPicker() {
      this.picker.type = "filterDepartment"
      this.picker.title = "选择中心"
      this.picker.columns = this.topDepartmentOptions
      this.picker.show = true
    },
    openTeacherFilterPicker() {
      this.picker.type = "filterTeacher"
      this.picker.title = "选择老师"
      this.picker.columns = this.teacherOptions
      this.picker.show = true
    },
    openCoursePackagePicker() {
      if (!this.formPopup.form.studentId) {
        Toast.fail("请先选择学员")
        return
      }
      if (this.remainInfo.loading) return
      if (!this.remainPackageList.length) {
        Toast.fail("暂无课包可选")
        return
      }
      this.picker.type = "formCoursePackage"
      this.picker.title = "选择课包"
      this.picker.columns = this.remainPackageList.map(p => ({
        text: this.formatCoursePackagePickerLabel(p),
        value: p.id
      }))
      this.picker.show = true
    },
    openConsumeNumPicker() {
      this.picker.type = "formConsumeNum"
      this.picker.title = "选择学员扣课课时"
      this.picker.columns = STUDENT_CONSUME_NUM_OPTIONS
      this.picker.show = true
    },
    openTeacherConsumeNumPicker() {
      this.picker.type = "formTeacherConsumeNum"
      this.picker.title = "选择老师计算课时"
      this.picker.columns = TEACHER_CONSUME_NUM_OPTIONS
      this.picker.show = true
    },
    openFormTeacherPicker() {
      if (!this.teacherOptions.length) {
        Toast.fail("暂无可选老师")
        return
      }
      this.picker.type = "formTeacher"
      this.picker.title = "选择老师"
      this.picker.columns = this.teacherOptions
      this.picker.show = true
    },
    onPickerConfirm(values, indexes) {
      const idx = Array.isArray(indexes) ? indexes[0] : indexes
      const col = this.picker.columns[idx]
      if (!col) {
        this.picker.show = false
        return
      }
      if (this.picker.type === "filterDepartment") {
        this.filters.topDepartmentId = col.value
        this.onRefresh()
      } else if (this.picker.type === "filterTeacher") {
        this.filters.teacherId = col.value
        this.onRefresh()
      } else if (this.picker.type === "filterTimeType") {
        this.filters.timeFilterType = col.value
        this.onRefresh()
      } else if (this.picker.type === "formCoursePackage") {
        const pkg = this.remainPackageList.find(x => x.id === col.value)
        if (pkg) this.applyRemainPackage(pkg)
      } else if (this.picker.type === "formTeacher") {
        this.formPopup.form.teacherId = col.value
        this.formPopup.form.teacherName = col.text
      } else if (this.picker.type === "formConsumeNum") {
        this.formPopup.form.consumeNum = col.value
      } else if (this.picker.type === "formTeacherConsumeNum") {
        this.formPopup.form.teacherConsumeNum = col.value
      }
      this.picker.show = false
    },
    async openStudentPicker() {
      this.studentPicker.keyword = (this.formPopup.form.studentName || "").trim()
      this.studentPicker.list = []
      this.studentPicker.show = true
      await this.searchStudents()
    },
    closeStudentPicker() {
      this.studentPicker.keyword = ""
      this.studentPicker.show = false
    },
    onStudentKeywordInput() {
      if (this.studentPicker.keywordTimer) clearTimeout(this.studentPicker.keywordTimer)
      this.studentPicker.keywordTimer = setTimeout(() => {
        this.searchStudents()
      }, 350)
    },
    async searchStudents() {
      this.studentPicker.loading = true
      try {
        const keyword = (this.studentPicker.keyword || "").trim()
        const payload = keyword ? { stuName: keyword } : {}
        const res = await fetchStudentPackageRemain(payload)
        this.studentPicker.list = resolveRemainSearchList(res)
      } catch (e) {
        this.studentPicker.list = []
      } finally {
        this.studentPicker.loading = false
      }
    },
    applyStudentFromRemain(info, preferredCoursePackageId = null, options = {}) {
      if (!info) return
      this.remainInfo.data = info
      this.remainInfo.loaded = true
      this.formPopup.form.studentId = info.studentId ?? this.formPopup.form.studentId
      this.formPopup.form.studentName = info.studentName || this.formPopup.form.studentName
      this.formPopup.form.topDepartmentId = info.topDepartmentId ?? null
      this.formPopup.form.topDepartmentName = info.topDepartmentName || ""
      const packages = normalizeCoursePackageList(info)
      let target = null
      if (preferredCoursePackageId !== null && preferredCoursePackageId !== undefined && preferredCoursePackageId !== "") {
        target = packages.find(x => x.id === preferredCoursePackageId) || null
      }
      if (target) this.applyRemainPackage(target, info, options)
    },
    async loadStudentRemain(stuName, preferredCoursePackageId = null, options = {}) {
      const name = (stuName || "").trim()
      if (!name) {
        this.resetRemainInfo()
        return
      }
      this.remainInfo.loading = true
      this.remainInfo.loaded = false
      try {
        const res = await fetchStudentPackageRemain({ stuName: name })
        const info = resolveRemainInfo(res, {
          stuName: name,
          studentId: this.formPopup.form.studentId
        })
        if (info) {
          this.applyStudentFromRemain(info, preferredCoursePackageId, options)
        } else {
          this.resetRemainInfo()
        }
      } catch (e) {
        this.resetRemainInfo()
      } finally {
        this.remainInfo.loading = false
      }
    },
    applyRemainPackage(pkg, remainData, options = {}) {
      const { defaultTeacher = true } = options
      const info = remainData || this.remainInfo.data || {}
      if (!pkg) return
      this.formPopup.form.coursePackageId = pkg.id ?? null
      this.formPopup.form.coursePackageName = (pkg.coursePackageName || "").trim()
      if (defaultTeacher) {
        this.formPopup.form.teacherId = pkg.teacherId ?? info.teacherId ?? null
        this.formPopup.form.teacherName = (pkg.teacherName || info.teacherName || "").trim()
      }
      this.formPopup.form.topDepartmentId = info.topDepartmentId ?? this.formPopup.form.topDepartmentId
      this.formPopup.form.topDepartmentName = info.topDepartmentName || this.formPopup.form.topDepartmentName
    },
    selectStudent(stu) {
      if (!stu) return
      this.formPopup.form.coursePackageId = null
      this.formPopup.form.coursePackageName = ""
      this.formPopup.form.teacherId = null
      this.formPopup.form.teacherName = ""
      this.formPopup.form.topDepartmentId = null
      this.formPopup.form.topDepartmentName = ""
      this.studentPicker.show = false
      this.remainInfo.loading = false
      if (stu.remainData) {
        this.applyStudentFromRemain(stu.remainData)
        return
      }
      this.loadStudentRemain(stu.studentName)
    },
    openCreate() {
      this.formPopup.mode = "create"
      this.formPopup.show = true
      this.resetRemainInfo()
      this.formPopup.form = {
        id: null,
        studentId: null,
        studentName: "",
        coursePackageId: null,
        coursePackageName: "",
        teacherId: null,
        teacherName: "",
        topDepartmentId: null,
        topDepartmentName: "",
        consumeDate: "",
        consumeNum: 1,
        teacherConsumeNum: 1
      }
    },
    async openEdit(row) {
      if (!row) return
      this.formPopup.mode = "edit"
      this.formPopup.show = true
      this.resetRemainInfo()
      const coursePackageId = row.coursePackageId ?? row.id ?? null
      const coursePackageName = (row.coursePackageName || "").trim()
      this.formPopup.form = {
        id: row.id,
        studentId: row.studentId ?? null,
        studentName: (row.studentName || "").trim(),
        coursePackageId,
        coursePackageName,
        teacherId: row.teacherId ?? null,
        teacherName: row.teacherName || "",
        topDepartmentId: row.topDepartmentId ?? null,
        topDepartmentName: row.topDepartmentName || "",
        consumeDate: ((row.consumeDate || row.consumeTime || "").trim() || "").slice(0, 10),
        consumeNum: Number(row.consumeNum) || 1,
        teacherConsumeNum: Number.isFinite(Number(row.teacherConsumeNum)) ? Number(row.teacherConsumeNum) : 1
      }
      await this.loadStudentRemain(row.studentName, coursePackageId, { defaultTeacher: false })
    },
    async submitForm() {
      if (this.formPopup.submitting) return
      const form = this.formPopup.form
      const consumeDate = (form.consumeDate || "").trim()
      const coursePackageId = form.coursePackageId
      const payload = {
        consumeDate,
        consumeNum: Number(form.consumeNum),
        teacherConsumeNum: Number(form.teacherConsumeNum),
        coursePackageId:
          coursePackageId !== null && coursePackageId !== undefined && coursePackageId !== ""
            ? coursePackageId
            : undefined,
        studentId: form.studentId !== null && form.studentId !== undefined && form.studentId !== "" ? Number(form.studentId) : undefined,
        teacherId: form.teacherId !== null && form.teacherId !== undefined && form.teacherId !== "" ? Number(form.teacherId) : undefined,
        topDepartmentId:
          form.topDepartmentId !== null && form.topDepartmentId !== undefined && form.topDepartmentId !== ""
            ? Number(form.topDepartmentId)
            : undefined
      }
      if (!Number.isFinite(payload.studentId)) return Toast.fail("请选择学员")
      if (payload.coursePackageId === null || payload.coursePackageId === undefined || payload.coursePackageId === "") {
        return Toast.fail("请选择课包")
      }
      if (!payload.consumeDate) return Toast.fail("请选择上课日期")
      if (!isValidDateString(payload.consumeDate)) return Toast.fail("上课日期格式错误，请使用 YYYY-MM-DD")
      if (!STUDENT_CONSUME_NUM_OPTIONS.some(x => Number(x.value) === Number(payload.consumeNum))) {
        return Toast.fail("请选择学员扣课课时")
      }
      if (!TEACHER_CONSUME_NUM_OPTIONS.some(x => Number(x.value) === Number(payload.teacherConsumeNum))) {
        return Toast.fail("请选择老师计算课时")
      }
      if (!Number.isFinite(payload.teacherId)) return Toast.fail("请选择老师")
      if (!Number.isFinite(payload.topDepartmentId)) return Toast.fail("缺少门店中心信息，请重新选择学员和课包")

      this.formPopup.submitting = true
      try {
        if (this.formPopup.mode === "create") {
          await createCourseConsumed(payload)
          Toast.success("新增成功")
        } else {
          await updateCourseConsumed({ ...payload, id: form.id })
          Toast.success("更新成功")
        }
        this.formPopup.show = false
        this.onRefresh()
      } finally {
        this.formPopup.submitting = false
      }
    },
    async onDelete(row) {
      if (!row) return
      const id = row.id
      if (id === null || id === undefined || id === "") return Toast.fail("缺少记录 ID")
      try {
        await Dialog.confirm({ title: "确认删除？", message: "删除后不可恢复" })
      } catch (e) {
        return
      }
      await deleteCourseConsumed(id)
      Toast.success("删除成功")
      this.onRefresh()
    }
  }
}
</script>

<style scoped>
.course-consumed-page {
  min-height: 100%;
  background: #f7f8fa;
}

.course-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.date-label-select {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #f27c34;
  border: 1px solid rgba(242, 124, 52, 0.45);
  border-radius: 999px;
  padding: 1px 8px;
  background: rgba(242, 124, 52, 0.08);
}

.date-label-select-icon {
  font-size: 11px;
}

.date-value {
  color: #323233;
  font-size: 13px;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-value--wide {
  flex: 0 0 auto;
  display: inline-block;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date-sep {
  color: #969799;
  flex: 0 0 auto;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
  flex: 0 0 auto;
}

.course-list {
  padding: 178px 12px calc(88px + var(--app-tabbar-offset, 52px));
  background: #f7f8fa;
  min-height: 100vh;
}

.consume-summary-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px 6px;
  background: #fff;
  border-bottom: 1px solid #f2f3f5;
}

.consume-summary-item {
  font-size: 13px;
  color: #646566;
  line-height: 1.4;
}

.consume-summary-amount {
  margin-left: 4px;
  color: rgb(242, 124, 52);
  font-size: 16px;
  font-weight: 700;
}

.consume-summary-count {
  margin-left: 4px;
  color: #323233;
  font-size: 16px;
  font-weight: 700;
}

.records-wrap {
  padding-bottom: 10px;
}

.empty {
  padding: 26px 0;
}

.consume-card {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  padding: 14px 14px 12px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(242, 124, 52, 0.22);
  margin-bottom: 10px;
}

.consume-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(90deg, rgba(242, 124, 52, 0.14) 0%, rgba(255, 255, 255, 0) 100%);
}

.consume-card::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 9px;
  bottom: 9px;
  width: 4px;
  border-radius: 999px;
  background: rgba(242, 124, 52, 0.72);
}

.consume-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.consume-student-name {
  font-size: 16px;
  font-weight: 700;
  color: #323233;
}

.consume-amount {
  font-size: 16px;
  font-weight: 700;
  color: rgb(242, 124, 52);
}

.consume-row {
  font-size: 13px;
  color: #646566;
  line-height: 1.6;
}

.consume-row--meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.consume-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.consume-op-btn {
  flex: 1;
  min-width: 60px;
  height: 26px;
  line-height: 24px;
  font-size: 12px;
}

.consume-op-btn--edit {
  color: #f27c34;
  border-color: rgba(242, 124, 52, 0.45);
  background: rgba(242, 124, 52, 0.08);
}

.consume-op-btn--delete {
  color: #d65d8c;
  border-color: rgba(214, 93, 140, 0.45);
  background: rgba(214, 93, 140, 0.08);
}

.course-detail-panel {
  margin: -4px 16px 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f7f8fa;
}

.course-detail-panel--loading {
  display: flex;
  justify-content: center;
  padding: 12px;
}

.course-detail-empty {
  margin: -4px 16px 12px;
  padding: 10px 12px;
  font-size: 13px;
  color: #969799;
  text-align: center;
  border-radius: 8px;
  background: #f7f8fa;
}

.course-detail-meta {
  font-size: 12px;
  color: #646566;
  line-height: 1.6;
}

.course-detail-meta + .course-detail-meta {
  margin-top: 2px;
}

.booking-popup-wrap,
.student-picker-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.booking-popup-scroll,
.student-list-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.popup-actions {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  background: #fff;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--app-tabbar-offset, 50px);
  padding: 10px 12px;
  background: #fff;
  box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.06);
  z-index: 1000;
}

.bottom-bar :deep(.van-button--primary) {
  background: var(--mg-orange, rgb(242, 124, 52));
  border-color: var(--mg-orange, rgb(242, 124, 52));
}

.theme-btn {
  background: rgb(242, 124, 52);
  border-color: rgb(242, 124, 52);
}

.student-list-wrap {
  padding: 0 12px 12px;
}

.student-item {
  padding: 12px;
  border-radius: 10px;
  background: #f7f8fa;
  margin-bottom: 8px;
}

.student-item.active {
  background: rgba(242, 124, 52, 0.08);
}

.student-item-name {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
}

.student-item-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.panel-loading,
.panel-empty {
  padding: 24px 0;
  text-align: center;
}
</style>
